import React, { useState } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import { useMutation } from '@apollo/client';
import { DELETE_CHARGE } from 'graphql/service';
import colors from 'constants/colors';
import { Container } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const ModalDeleteCharge = ({
  buttonIcon,
  iconStyle,
  charge,
  setBill,
}) => {

    const [isOpen, setIsOpen] = useState(false)

    const [deleteCharge, {loading}] = useMutation(DELETE_CHARGE, {
      onCompleted: (data) => {
        setBill(data.deleteCharge)
        setIsOpen(false)
      },
      onError: (error) => {
        debouncedErrorMessage(error.message);
      }
    })

  const handleDelete = () => {
    if(loading) return
    deleteCharge({
      variables: {
        input: {
          chargeId: charge.chargeId
        }
      },
    });
  }

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        buttonIcon={buttonIcon}
        iconStyle={iconStyle}
        className="modal-danger"
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            height: 100%;
            .close {
              z-index: 200;
            }   
            .modal-body{
              height: 100%;
              padding: 24px;
            }
          }
          background: ${colors.black5};
          top: 179px;
        `}
      >
        <Container>
          <div className='text'>{`Delete the charge: "${charge.description}" ?`}</div>
          <div className='buttonContainer'>
            <Button
              danger
              onClick={() => setIsOpen(false)}
              additionalstyle={`
                width: 79px;
                margin-right: 16px;
              `} 
            >
              Cancel
            </Button>
            <Button
              success
              onClick={handleDelete}
              data-loading={loading}
              additionalstyle={`
                width: 78px;
              `}
            >
              {loading? null: 'Delete'}
            </Button>
          </div>
        </Container>
      </MainModal>
    </>
  );
}

export default ModalDeleteCharge;
